import { doc, onSnapshot } from "firebase/firestore";
import React, { useContext, useEffect, useState } from "react";
import { ChatContext } from "../context/ChatContext";
import { db } from "../firebase";
import Message from "./Message";

const Messages = () => {
  const [messages, setMessages] = useState([]);
  const { data } = useContext(ChatContext);

  useEffect(() => {
    if (data.chatId === "null") return;
    
    const collection = data.isGroupChat ? "groupChats" : "chats";
    const unSub = onSnapshot(doc(db, collection, data.chatId), (doc) => {
      if (doc.exists()) {
        const docData = doc.data();
        setMessages(docData.messages || []);
      } else {
        setMessages([]);
      }
    });

    return () => {
      unSub();
    };
  }, [data.chatId, data.isGroupChat]);

  return (
    <div className="messages">
      {messages.map((m) => (
        <Message message={m} key={m.id} />
      ))}
    </div>
  );
};

export default Messages;
